import React, { Component } from 'react';
import classNames from 'classnames';

class SitebarDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  static defaultProps = {
    fixedHeight: null,
    width: 300,
    open: false,
    marginLeft: null,
    addScrollWhenExceedsViewport: false,
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.fixedHeight) {
      return;
    }
    /*
    * This is to add a scrollbar when the menu is too tall for the screen.
    * Ideally we'd have this as default behaviour for every dropdown that gets too big, but this method
    * relies on the dropdown content being available when the dropdown is rendered, not loaded after the fact
    * e.g. the notifications dropdown
    */
    if (this.props.addScrollWhenExceedsViewport && nextProps.open !== this.props.open) {
      const RENDERED_HEIGHT = this.refs.menu.offsetHeight;
      if (RENDERED_HEIGHT === 0) {
        return;
      } else if (!nextProps.open) {
        this.setState({ height: RENDERED_HEIGHT });
      } else {
        const MAX_HEIGHT = 1025;
        const TOP_BAR_HEIGHT = 52;
        const VIEWPORT_HEIGHT = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        const MENU_HEIGHT = Math.min(VIEWPORT_HEIGHT - TOP_BAR_HEIGHT, MAX_HEIGHT, RENDERED_HEIGHT);
        this.setState({ height: MENU_HEIGHT });
      }
    }
  }

  render() {
    const { children, width, open, marginLeft, fixedHeight } = this.props;
    const { height } = this.state;
    const classes = classNames({
      'sitebar-dropdown': true,
      'sitebar-dropdown--open': open,
    });
    return (
      <div className={classes} ref="menu"
        style={{height: fixedHeight || height, width, marginLeft}}>
        {children}
      </div>
    );
  }
}

export default SitebarDropdown;
